import {Typography} from "@mui/material";

export const AdminInfoContent = () => {



    return {
        title: 'Active Jobs',
        content: (
            <>
                <Typography paragraph>
                   Active Jobs is a list of all the currently running jobs.
                </Typography>

                <ul>
                    <li>
                    If they run for a long time, feel free to Cancel them.
                    </li>

                    <li>
                        A job that runs more than 10 minutes might be a problem.
                    </li>

                    <li>
                        Jobs with more complex data processing might take longer.
                    </li>

                </ul>
            </>
        )
    };


};